// @flow
import React from 'react';
import CareersPageFilters from './jobs-filter/CareersPageFilters';
import {
	getAllFiltersAvailable,
	getLocationFilters,
	isRadiusSearchEnabled,
	isFilterAvailable,
} from './jobs-filter/CareersPageFilterService';
import LocationFilter from './location-filter/LocationFilter';
import { CS_Space, CS_Text } from '../visual_components';
import * as SVG_Icons from '../svg_icons';

export default function CareersPageSidebar() {
	return (
		<div className="hidden-xs js-filters">
			<CS_Space vertical size={5} />
			<div className="visible-xs">
				<div className="clearfix">
					<CS_Text size={1}>
						<CS_Space vertical size={2} />
						FILTER
					</CS_Text>
					<div className="pull-right">
						<a href="/">
							<button type="button" className="btn btn-default">
								Clear All
							</button>
						</a>
						<CS_Space size={3} />
						<button className="btn btn-default">{SVG_Icons.chevron_right}</button>
					</div>
				</div>
				<CS_Space vertical size={6} />
				<div className="rb-divider" />
				<CS_Space vertical size={5} />
			</div>
			{isRadiusSearchEnabled() && <LocationFilter filters={getLocationFilters()} />}
			<CareersPageFilters filters={getAllFiltersAvailable()} is_filter_available={isFilterAvailable()} />
		</div>
	);
}
